export default "__VITE_ASSET__DF9$hlMz__"